import React from "react";
import { Reveal, Overline } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { INSIGHTS } from "../lib/data";

export const Insights = () => (
  <section id="insights" data-testid="insights" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36">
    <div className="flex items-end justify-between mb-16">
      <Reveal>
        <Overline>Insights</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
          From the desk.
        </h2>
      </Reveal>
    </div>

    <div className="border-t border-line">
      {INSIGHTS.map((a, i) => (
        <Reveal key={i} delay={i * 0.05}>
          <a href="#insights" data-testid={`insight-${i}`} className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-center py-8 border-b border-line hover:px-4 transition-all duration-500">
            <div className="md:col-span-2 font-mono text-[10px] uppercase tracking-[0.2em] text-brass">{a.cat}</div>
            <h3 className="md:col-span-7 font-serif text-2xl sm:text-3xl text-bone group-hover:text-brass transition-colors">{a.title}</h3>
            <div className="md:col-span-2 font-mono text-xs uppercase tracking-[0.15em] text-mute">{a.date} · {a.read}</div>
            <div className="md:col-span-1 flex md:justify-end">
              <ArrowUpRight size={22} className="text-mute group-hover:text-brass group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
            </div>
          </a>
        </Reveal>
      ))}
    </div>
  </section>
);
